import type { TesterRow } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { QueryErrorNotice } from '../../query-error-notice.js';

// Task 11 (#98.3): Tester-Tabelle — eine Zeile je Tester (zugewiesen/erledigt/offen).
// Grundmenge = ZUGEWIESENE In-Scope-Plan-Items dieses Plans (loadTestersBreakdown,
// dieselbe Zahl wie scope-table.tsx' Zuweisungs-Fortschrittszeile) — Plan-gescopt.
export function TestersTableCard({
  testers,
  isTestersLoading,
  isTestersError,
  onRetryTesters,
}: {
  testers: TesterRow[] | undefined;
  isTestersLoading: boolean;
  isTestersError: boolean;
  onRetryTesters: () => void;
}) {
  const { t } = useTranslation();

  return (
    <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
      <div className="mb-1 flex items-center justify-between">
        <h2 className="text-sm font-bold text-text-primary">{t('reporting.testers.title')}</h2>
      </div>
      <p className="mb-3 text-[10px] text-text-muted">{t('reporting.scopePlan')}</p>
      {isTestersError ? (
        <QueryErrorNotice onRetry={onRetryTesters} />
      ) : isTestersLoading ? (
        <div className="text-sm text-text-muted">{t('common.loading')}</div>
      ) : testers && testers.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="text-[11px] uppercase tracking-wide text-text-muted">
                <th className="px-4 py-2">{t('reporting.testers.name')}</th>
                <th className="px-4 py-2">{t('reporting.testers.assigned')}</th>
                <th className="px-4 py-2">{t('reporting.testers.done')}</th>
                <th className="px-4 py-2">{t('reporting.testers.open')}</th>
              </tr>
            </thead>
            <tbody>
              {testers.map((row) => (
                <tr key={row.user_id} className="border-t border-[var(--border)]">
                  <td className="px-4 py-2 text-text-body">{row.display_name}</td>
                  <td className="px-4 py-2 tabular-nums text-text-primary">{row.assigned}</td>
                  <td className="px-4 py-2 tabular-nums text-status-pass">{row.done}</td>
                  <td className="px-4 py-2 tabular-nums text-text-body">{row.open}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-sm text-text-muted">{t('reporting.testers.empty')}</div>
      )}
    </section>
  );
}
